<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <h3 class="page-title obs-card-title" style="text-align:center">File Viewer</h3>
        <div class="section-wrapper">
          <table class="table table-bordered table-striped table-condensed fix-tablelayout">
            <thead>
              <tr>
                <th style="width: 5%;">Sr. No.</th>
                <th>File Name</th>
                <th>Preview</th>
                <th style="width: 5%;">Download</th>
              </tr>
            </thead>
            <tbody>
              <tr style="cursor:pointer;" *ngFor="let file of descriptionData; let i=index ">
                <td>
                  {{i+1}}</td>
                <td>
                  {{file.FilePath | fileName}}</td>
                <td>
                  <div class="preview-wrapper">
                    <ara-files-previewer *ngIf="[file]" [files]="[file]"></ara-files-previewer>
                  </div>
                </td>
                <td>
                  <a [href]="file.FilePath" target="_blank"><i class="fa fa-download"></i></a></td>
              </tr>
            </tbody>
            <div style="width: 500px;margin-top:15px;color: red" *ngIf="descriptionData.length===0">No Files</div>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
